import * as messageService from "../../services/message.service";
import * as userService from '../../services/user.service';


const state = {
    adminUserPaginateData:{},
    adminUserPaginate:{},
    userAll:{},
    userList:{},
    userById:{},
    userDropdownList:[],
    userDropdownListBasedFullName:[],
    isUserSettingUpdate:false,
};

const getters = {
    getAdminUserPaginate:state => (state.adminUserPaginate),
    getAdminUserPaginateData:state => (state.adminUserPaginateData),
    gettUserAll:state => (state.userAll),
    gettUserList:state => (state.userList),
    getUserById:state => (state.userById),
    getUserDropdownList:state => (state.userDropdownList),
    getUserDropdownListBasedFullName:state => (state.userDropdownListBasedFullName),
    getIsUserSettingUpdate:state => (state.isUserSettingUpdate)
};

const actions = {
    //Admin 2022-07-03
    async fetchAdminUserPaginateData({ commit }, obj){
       commit('setAdminQuotePaginate', obj)
        try {
            const response = await userService.listPage(obj);
            commit('setAdminUserPaginateData', response.data);

        } catch (error) {
            console.log('something wrong - fetchAdminUserPaginateData', error);
        }
    },

    async fetchUserAll({ commit } ){
        try {
            const response = await userService.all();

            commit('setUserAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },

    async fetchUserList({ commit } ){
        try {
            const response = await userService.list();

            commit('setUserList', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },

    async fetchUserById({commit}, id){
        try {
            const response = await userService.single(id);
            commit('setUserById', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },

    async fetchUserDropdownList({ commit } ){
        try {
            const response = await userService.dropdownList();

            commit('setUserDropdownList', response.data);
        } catch (error) {
            console.log('fetchUserDropdownList - Something wrong', error)
        }
    },

    async fetchUserDropdownListBasedFullName({ commit } ){
        try {
            const response = await userService.dropdownListBasedFullName();

            commit('setUserDropdownListBasedFullName', response.data);
        } catch (error) {
            console.log('fetchUserDropdownListBasedFullName - Something wrong', error)
        }
    },

    fetchIsUserSettingUpdate({ commit }, status ){
      try {
          commit('setIsUserSettingUpdate', status);
      } catch (error) {
          console.log('fetchIsUserSettingUpdate - Something wrong', error)
      }
  },
};

const mutations = {
    setAdminUserPaginate:(state, res) => (
        state.adminUserPaginate =  res
    ),
    setAdminUserPaginateData:(state, res) => (
        state.adminUserPaginateData =  res
    ),
    setUserAll:(state, res) => (
        state.userAll =  res
    ),
    setUserList:(state, res) => (
        state.userList =  res
    ),
    setUserById:(state, res) => (
        state.userById =  res
    ),
    setUserDropdownList:(state, res) => {
        state.userDropdownList =  res
    },
    setUserDropdownListBasedFullName:(state, res) => {
        state.userDropdownListBasedFullName =  res
    },
    setIsUserSettingUpdate:(state, res) => {
      state.isUserSettingUpdate = res
    }
};

export default{
    state,
    getters,
    actions,
    mutations,
}
